import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
interface LanguageSelectorProps {
  onComplete: () => void;
}
export function LanguageSelector({
  onComplete
}: LanguageSelectorProps) {
  const {
    setLanguage,
    completeSelection
  } = useLanguage();
  const handleSelect = (lang: 'en' | 'es') => {
    setLanguage(lang);
    completeSelection();
    onComplete();
  };
  return <motion.div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0A0A]" initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeInOut'
  }} data-id="element-71">
      <div className="absolute inset-0 bg-gold-glow opacity-40 pointer-events-none" data-id="element-72" />

      <div className="relative z-10 flex flex-col items-center text-center px-4" data-id="element-73">
        <motion.h1 className="text-3xl md:text-5xl font-serif text-brand-gold tracking-widest uppercase mb-4 drop-shadow-[0_0_15px_rgba(201,168,76,0.3)]" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} data-id="element-74">
          KRLY GOLD TATTOO
        </motion.h1>

        <motion.p className="text-brand-white/80 font-sans font-light text-sm md:text-base mb-8 tracking-widest uppercase" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} data-id="element-75">
          Fine Art Tattoo | Miami, FL
        </motion.p>

        <motion.div className="w-24 h-px bg-brand-gold mb-12 opacity-50" initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} data-id="element-76" />

        <motion.h2 className="text-xl md:text-2xl font-serif text-brand-white mb-10" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} data-id="element-77">
          Choose Your Language / Elige Tu Idioma
        </motion.h2>

        <motion.div className="flex flex-col sm:flex-row gap-6 w-full max-w-md justify-center" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1,
        duration: 0.8
      }} data-id="element-78">
          <button onClick={() => handleSelect('en')} className="flex-1 py-4 px-8 border border-brand-gold text-brand-gold font-serif text-lg tracking-widest uppercase transition-all duration-300 hover:bg-brand-gold hover:text-brand-black focus:outline-none focus:ring-2 focus:ring-brand-gold focus:ring-offset-2 focus:ring-offset-brand-black" aria-label="Select English" data-id="element-79">
            🇺🇸 English
          </button>
          <button onClick={() => handleSelect('es')} className="flex-1 py-4 px-8 border border-brand-gold text-brand-gold font-serif text-lg tracking-widest uppercase transition-all duration-300 hover:bg-brand-gold hover:text-brand-black focus:outline-none focus:ring-2 focus:ring-brand-gold focus:ring-offset-2 focus:ring-offset-brand-black" aria-label="Seleccionar Español" data-id="element-80">
            🇪🇸 Español
          </button>
        </motion.div>
      </div>

      <motion.p className="absolute bottom-8 text-brand-gold text-xs tracking-widest uppercase opacity-40" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 0.8
    }} data-id="element-81">
        Miami, FL — Fine Art Tattoo Studio
      </motion.p>
    </motion.div>;
}